import FormRandomQuestionBackOffice from './form-random-question';

export default FormRandomQuestionBackOffice;
